import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconComments = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.09375 0C2.72813 0 0 2.30813 0 5.15625C0 6.16406 0.346875 7.10063 0.9375 7.89563V11.25L3.46781 9.80437C4.26375 10.1269 5.1525 10.3125 6.09375 10.3125C9.45938 10.3125 12.1875 8.00438 12.1875 5.15625C12.1875 2.30813 9.45938 0 6.09375 0Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15 8.90625C15 7.98094 14.5978 7.12781 13.9247 6.43219C13.2412 9.70125 9.99374 12.1875 6.09374 12.1875C5.99718 12.1875 5.90436 12.1706 5.8078 12.1678C6.77905 12.7659 8.02124 13.125 9.37499 13.125C9.79593 13.125 10.2056 13.0875 10.6003 13.0219L14.0625 15V11.25H14.0512C14.6503 10.5797 15 9.77344 15 8.90625Z",
		fill: "currentColor"
	})]
});
export default SvgIconComments;
